import { withStyles } from "@material-ui/core";
import { format } from "date-fns";
import { APP_DATE_FORMAT } from "../constants";
import StyledToolTip from "../../../common/StyledToolTip";

const styles = (theme) => ({
  dayWithDotContainer: {
    position: "relative",
  },
  dayWithDot: {
    position: "absolute",
    height: 0,
    width: 0,
    border: "3px solid",
    borderRadius: 4,
    borderColor: theme.palette.primary.main,
    right: "46%",
    top: "76%",
  },
  dayWithDotSelected: {
    borderColor: theme.white,
  },
  holiday: {
    "& button": {
      color: theme.KPI.KPINegative,
    },
  },
  disabled : {
    opacity : 0.7
  }
});

const getHolidayClasses = (classes, isDisabled) => {
  return `${classes.holiday} ${isDisabled ? classes.disabled : ''}`;
};

const InitializedPlanDay = withStyles(styles)(
  ({ DayComponent, isSelectedDate, classes }) => {
    return (
      <div className={classes.dayWithDotContainer}>
        {DayComponent}
        <div
          className={`${classes.dayWithDot} ${
            isSelectedDate ? classes.dayWithDotSelected : ""
          }`}
        ></div>
      </div>
    );
  }
);

const CustomDay = withStyles(styles)(
  ({ dayComponent, classes, isHoliday, isDisabled, holidayName }) => (
    <StyledToolTip title={holidayName ? holidayName : ''}>
      <div className={isHoliday ? getHolidayClasses(classes, isDisabled) : null}>
        {dayComponent}
      </div>
    </StyledToolTip>
  )
);

const CustomDateRenderer = ({
  day,
  selectedDate,
  dayComponent,
  isInitializedPlanDate,
  isHoliday,
  isDisabled,
  holidayName,
  dayInCurrentMonth
}) => {
  const DayComponent = (
    <CustomDay
      dayComponent={dayComponent}
      isHoliday={isHoliday}
      isDisabled={isDisabled}
      holidayName = {holidayName}
    />
  );
  if (isInitializedPlanDate && dayInCurrentMonth) {
    return (
      <InitializedPlanDay
        dayInCurrentMonth
        DayComponent={DayComponent}
        isSelectedDate={
          format(selectedDate, APP_DATE_FORMAT) === format(day, APP_DATE_FORMAT)
        }
      />
    );
  }
  return DayComponent;
};

export { CustomDateRenderer };
